import { useCallback, useState } from "react"

import { CONVERSATION_SEARCH_TYPE, type ConversationSearchType } from "../types"

/**
 * Owns the table's search box and cluster-filter state. A manually-typed query always
 * searches all fields and drops any cluster filter -- SIMULATION_OUTPUT_ID mode and
 * clusterFilterIds are only ever set by a visualizer click (see
 * useConversationsVisualizerSelection), and neither should stick once the user edits
 * or clears the box themselves.
 */
export function useConversationsSearchState() {
  const [searchResetKey, setSearchResetKey] = useState(0)
  const [searchQuery, setSearchQueryState] = useState("")
  const [searchType, setSearchType] = useState<ConversationSearchType>(
    CONVERSATION_SEARCH_TYPE.ALL_FIELDS,
  )
  const [clusterFilterIds, setClusterFilterIds] = useState<string[] | null>(
    null,
  )

  const setSearchQuery = useCallback((value: string) => {
    setSearchResetKey((current) => current + 1)
    setSearchQueryState(value)
  }, [])

  const handleSearchQueryChange = useCallback((value: string) => {
    setSearchType(CONVERSATION_SEARCH_TYPE.ALL_FIELDS)
    setClusterFilterIds(null)
    setSearchQueryState(value)
  }, [])

  const handleClearSearch = useCallback(() => {
    setSearchResetKey((current) => current + 1)
    setSearchType(CONVERSATION_SEARCH_TYPE.ALL_FIELDS)
    setClusterFilterIds(null)
    setSearchQueryState("")
  }, [])

  return {
    clusterFilterIds,
    handleClearSearch,
    handleSearchQueryChange,
    searchQuery,
    searchResetKey,
    searchType,
    setClusterFilterIds,
    setSearchQuery,
    setSearchType,
  }
}
